import { Button } from '@fluentui/react-components';
import { RotateCcw } from 'lucide-react';
import { previewEmailBody } from '../hooks/useEmailContext';
import { senderInitials } from '../lib/sender';

interface ReplyingToPanelProps {
  senderName: string;
  senderEmail: string;
  subject: string;
  body: string;
  onRefresh?: () => void;
}

export function ReplyingToPanel({
  senderName,
  senderEmail,
  subject,
  body,
  onRefresh,
}: ReplyingToPanelProps) {
  return (
    <section className="overflow-hidden rounded-xl border border-sf-primary/15 bg-sf-primary-light/60">
      <div className="flex items-center gap-2.5 px-3.5 pt-3 pb-2.5">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sf-primary text-[11px] font-semibold text-sf-secondary">
          {senderInitials(senderName, senderEmail)}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-sf-primary/60">
            Replying to
          </p>
          <p className="truncate text-sm font-semibold leading-tight text-sf-dark">
            {senderName || senderEmail || 'Unknown sender'}
          </p>
          {senderName && senderEmail && (
            <p className="truncate text-[11px] leading-tight text-sf-gray">{senderEmail}</p>
          )}
        </div>
        {onRefresh && (
          <Button
            appearance="subtle"
            size="small"
            icon={<RotateCcw className="h-3.5 w-3.5" />}
            onClick={onRefresh}
            aria-label="Refresh email"
            title="Not seeing the right email? Refresh"
          />
        )}
      </div>
      <div className="border-t border-sf-primary/10 bg-sf-surface/70 px-3.5 py-2.5">
        <p className="line-clamp-2 break-words text-sm font-semibold leading-snug text-sf-dark">
          {subject || '(No subject)'}
        </p>
        {body && (
          <p className="mt-1 line-clamp-3 break-words text-xs leading-relaxed text-sf-body/80">
            {previewEmailBody(body)}
          </p>
        )}
      </div>
    </section>
  );
}
